import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from 'reducers';
import localStorageMiddleware from './middlewares/localStorageMiddleware';
import { isDevelopment } from 'constants/values';

let composeFunctions = [
  applyMiddleware(thunkMiddleware, localStorageMiddleware),
];

if (isDevelopment) {
  composeFunctions = [
    ...composeFunctions,
    window.__REDUX_DEVTOOLS_EXTENSION__ &&
      window.__REDUX_DEVTOOLS_EXTENSION__(),
  ];
}

const configureStore = ({ localStorageInitialState }) =>
  createStore(
    rootReducer,
    localStorageInitialState,
    compose(...composeFunctions),
  );

export default configureStore;
